import { makeAutoObservable } from 'mobx';
import { LeadStatus } from '../interfaces/ILead';

export default class ChangeLeadStatusStore {
    status: LeadStatus | null = null;
    onChangeStatus: ((status: LeadStatus, note: string) => Promise<void>) | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    open(status: LeadStatus, onChangeStatus: (status: LeadStatus, note: string) => Promise<void>) {
        this.status = status;
        this.onChangeStatus = onChangeStatus;
    }

    async changeStatus(note: string) {
        await this.onChangeStatus!(this.status!, note);
        this.close();
    }

    close() {
        this.status = null;
        this.onChangeStatus = null;
    }

    isOpen(): boolean {
        return !!this.onChangeStatus;
    }

    clear() {
        this.status = null;
        this.onChangeStatus = null;
    }
}
